import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MESSAGES_UPLOAD_MEDIA_BEGIN,
  MESSAGES_UPLOAD_MEDIA_SUCCESS,
  MESSAGES_UPLOAD_MEDIA_FAILURE,
  MESSAGES_UPLOAD_MEDIA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function uploadMedia(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: MESSAGES_UPLOAD_MEDIA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = fetch(args.uploadUrl, {
        method: 'PUT',
        body: args.file,
        headers: {
          'Content-Type': args.file.type,
        },
      });

      doRequest.then(
        (res) => {
          dispatch({
            type: MESSAGES_UPLOAD_MEDIA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MESSAGES_UPLOAD_MEDIA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUploadMediaError() {
  return {
    type: MESSAGES_UPLOAD_MEDIA_DISMISS_ERROR,
  };
}

export function useUploadMedia() {
  const dispatch = useDispatch();

  const { uploadMediaPending, uploadMediaError } = useSelector(
    (state) => ({
      uploadMediaPending: state.messages.uploadMediaPending,
      uploadMediaError: state.messages.uploadMediaError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(uploadMedia(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUploadMediaError());
  }, [dispatch]);

  return {
    uploadMedia: boundAction,
    uploadMediaPending,
    uploadMediaError,
    dismissUploadMediaError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MESSAGES_UPLOAD_MEDIA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        uploadMediaPending: true,
        uploadMediaError: null,
      };

    case MESSAGES_UPLOAD_MEDIA_SUCCESS:
      // The request is success
      return {
        ...state,
        uploadMediaPending: false,
        uploadMediaError: null,
      };

    case MESSAGES_UPLOAD_MEDIA_FAILURE:
      // The request is failed
      return {
        ...state,
        uploadMediaPending: false,
        uploadMediaError: action.data.error,
      };

    case MESSAGES_UPLOAD_MEDIA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        uploadMediaError: null,
      };

    default:
      return state;
  }
}
